<template>
  <el-form :model="editCourseInfoForm" :rules="editCourseInfoRules" ref="editCourseInfoForm" class="edit_course_form">
    <el-form-item label="课程名称" prop="courseName">
      <el-input v-model.trim="editCourseInfoForm.courseName" autocomplete="off" placeholder="请输入课程名称" maxlength="30"></el-input>
    </el-form-item>
    <el-form-item label="课程简介" prop="courseIntroduction">
      <el-input type="textarea" v-model="editCourseInfoForm.courseIntroduction" placeholder="请输入课程简介" rows="3" maxlength="150" show-word-limit></el-input>
    </el-form-item>
    <div style="display:flex;">
      <div style="width: 40%">
        <el-form-item label="专业科目" prop="subject" class="subject">
          <el-select v-model="editCourseInfoForm.subject" placeholder="请选择所属科目" disabled>
            <div v-if="subjectList.length>0">
              <el-option
                v-for="item in subjectList"
                :key="item.id"
                :label="item.name"
                :title="item.name"
                :value="item.id">
                {{item.name}}
              </el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="课时数" prop="classHour" class="classHour">
          <el-input v-model="editCourseInfoForm.classHour" placeholder="请输入课时数" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"/>
        </el-form-item>
      </div>
      <div style="width: 40%" v-if="productFlag==2||productFlag==3||productFlag==4||productFlag==7">
        <el-form-item label="选择岗位" prop="post" class="post">
          <el-select v-model="editCourseInfoForm.post" multiple placeholder="请选择岗位" disabled>
            <el-option
              v-for="item in postList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </div>
    <el-form-item label="课程封面" prop="coursePic">
      <el-upload
        class="avatar-uploader"
        :data="uploadData"
        :disabled="isDisabled"
        :action="uploadSrc"
        :headers="headers"
        accept=".jpg,.png,.jpeg"
        :show-file-list="false"
        :on-progress="handleAvatarProgress"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload" v-model="pic">
        <img v-if="pic" :src="pic" class="avatar">
        <i v-else :class="uploadIcon"></i>
      </el-upload>
    </el-form-item>
    <!-- <el-form-item label="课程详情" prop="courseIntroduction" v-if="productFlag==3">
      <v-editor v-model="editCourseInfoForm.courseDetails" class="course_details"></v-editor>
    </el-form-item> -->
    <div class="set_catalog_title" v-if="professional==2">
      <h2>平台跳转设置</h2>
    </div>
    <el-form-item label="三天下" v-if="professional==2">
      <p class="tips">注：该参数的改变，将影响整个课程下配套的“三天下”业务系统发生变化，包括实训、测验、测评等模块。如频繁切换，已经产生的作答数据，可能会丢失、紊乱。</p>
      <ul class="platform_list" v-if="platformList.length>0">
        <li v-for="item in platformList" :key="item.id">
          <span class="platform_name">{{item.platformName}}：</span>
          <el-radio-group v-model="item.radio">
            <el-radio :label="val.id" v-for="val in item.platformPathList" :key="val.id">{{val.tag}}</el-radio>
          </el-radio-group>
        </li>
      </ul>
      <div v-else class="null_box">
        <img src="@/assets/image/sources/table_no_data.png" alt="加载失败"/>
        <p>暂无数据</p>
      </div>
    </el-form-item>

  </el-form>
</template>
<script>
import * as api from "../../../api/courseApi";
import * as subjectApi from "../../../api/statisticsApi";
import vEditor from "@/components/wjlEditor/index.vue";
export default {
  props: {
    editCourseInfoForm: {
      type: Object,
      default: function(){
        return {
          courseName: '',
          courseIntroduction: '',
          subject: '',
          classHour: '',
          coursePic: '',
          courseDetails: '',
          productFlag: sessionStorage.getItem('productFlag'),
          post: []
        }
      }
    },
    imageUrl: {
      type: String,
      default: ''
    },
    courseId: {
      type: Number
    },
  },
  components:{ vEditor },
  computed: {
    uploadData(){
      return {
        "savepath":"cjdd/course/socialTraining/"
      }
    },
    headers(){
      return {
        "Authorization": "bearer "+localStorage.getItem('Authorization')
      }
    }
  },
  data() {
    return {
      platformList: [], // 平台跳转参数
      subjectList: [],
      editCourseInfoRules:{
        courseName: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        subject:[
          { required: true, message: '请选择所属科目', trigger: 'change' }
        ],
        coursePic: [
          { required: false, message: '请上传封面', trigger: 'change' }
        ],
        post: [
          { required: true, message: '请选择岗位', trigger: 'change' }
        ],
      },
      isDisabled: false,
      pic: '',
      uploadIcon: 'el-icon-plus avatar-uploader-icon',
      uploadSrc: `${process.env.UPLOAD_NAME}/file/uploadImage`,
      professional: sessionStorage.getItem('professional'),
      productFlag: sessionStorage.getItem('productFlag'),
      postList: []
    }
  },
  created() {
    this.getPlatformPath()
    subjectApi.FindStationBySubjectId(this.editCourseInfoForm.subject).then(rs=>{
      // that.editCourseInfoForm.post = []
      if(rs.code==0){
        this.postList = rs.data
        // if(rs.data.length>0){
        //   rs.data.forEach(v=>{
        //     that.editCourseInfoForm.post.push(v.id)
        //   })
        // }else{
        //   that.editCourseInfoForm.post = []
        // }
      }else{
        this.$messageError(rs.msg)
      }
    })
    this.pic = this.imageUrl
    this.getSubjectList(this.professional)
  },
  methods: {
    getPlatformPath(){
      api.getPlatformPath(this.courseId).then(rs=>{
        if(rs.code==0){
          rs.data.forEach(v=>{
            let radio = null
            v.platformPathList.forEach(val=>{
              if(val.isBind==1){
                radio = val.id
              }
            })
            this.$set(v, "radio", radio)
          })
          this.platformList = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    //获取科目列表
    getSubjectList(id){
      let that = this
      api.getSubjectList().then((rs)=>{
        if(rs.code==0){
          that.subjectList = []
          let obj = {}
          rs.data.forEach((item,i)=>{
            if(item.professionId == id){
              obj = {
                id: item.id,
                name: item.name,
                professionId: item.professionId
              }
              that.subjectList.push(obj)
            }
          })
        }else{
          this.$messageError(rs.msg)
        }
      }).catch((error)=>{
        console.log(error)
      })
    },
    getTreeList(data){
      for(var i=0;i<data.length;i++){
        this.subjectList.push(data[i])
        if(data[i].next.length<1){
          data[i].next=undefined;
        }else {
          this.getTreeList(data[i].next);
        }
      }
      return data;
    },
    //上传图片
    handleAvatarSuccess(res, file) {
      let that = this
      this.pic = URL.createObjectURL(file.raw);
      this.editCourseInfoForm.coursePic = res.data.imagePath
      this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
      this.$refs['editCourseInfoForm'].validateField('coursePic', val => {
        if (!val) {
          that.editCourseInfoRules.coursePic[0].message='请上传封面'
          that.isDisabled = false
        }
      })
    },
    handleAvatarProgress(){
      let that = this
      this.pic = '';
      this.editCourseInfoForm.coursePic = ''
      this.uploadIcon = 'el-icon-loading avatar-uploader-icon'
      this.$refs['editCourseInfoForm'].validateField('coursePic',(val,callback)=>{
        that.editCourseInfoRules.coursePic[0].message='上传中，请稍后'
        that.isDisabled = true
      })
    },
    beforeAvatarUpload(file) {
      this.uploadIcon = 'el-icon-loading avatar-uploader-icon'
      let jpg = file.type === 'image/jpeg'||file.type === 'image/jpg'
      let png = file.type === 'image/png'
      const isJPG = jpg||png;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error('上传封面图片仅限 JPG 和 PNG 格式!');
        this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
      }
      if (!isLt10M) {
        this.$message.error('上传封面图片大小不能超过 10MB!');
        this.uploadIcon = 'el-icon-plus avatar-uploader-icon'
      }
      return isJPG && isLt10M;
    },
    clickConfirm(){
      let that = this
      this.savePlatform(); // 保存平台跳转参数
      this.$refs['editCourseInfoForm'].validate((valid) => {
        if (valid) {
          let arr = []
          if(that.editCourseInfoForm.post.length>0){
            that.editCourseInfoForm.post.forEach(v=>{
              arr.push({
                "courseId": '',
                "stationId": v,
                "subjectId": that.editCourseInfoForm.subject
              })
            })
          }else{
            arr = []
          }
          let updataData = {
            "courseLogo": that.editCourseInfoForm.coursePic,
            "courseName": that.editCourseInfoForm.courseName,
            "courseProfessional": that.professional,
            "subjectId": that.editCourseInfoForm.subject,
            "id": that.courseId,
            "courseHour": that.editCourseInfoForm.classHour,
            "courseContext": that.editCourseInfoForm.courseIntroduction,
            "detail": that.editCourseInfoForm.courseDetails,
            "courseStationList": arr
          }
          api.updateCourse(updataData).then((rs)=>{
            if(rs.code==0){
              this.$messageSuccess('课程信息修改成功')
              this.$parent.courseReload()
            }else{
              this.$messageError(rs.data.msg)
            }
          }).catch((error)=>{
            console.log(error)
          })
        }else{
          console.log('error')
          return false
        }
      })
    },
     // 保存平台跳转参数
    savePlatform(){
      let arr = []
      this.platformList.forEach(v=>{
        arr.push({
          "courseId": this.courseId,
          "pathId": v.radio
        })
      })
      api.savePlatformPath(arr)
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  watch:{
    imageUrl(val){
      this.pic = val
    }
  }
}
</script>
<style lang="scss" scoped>
  .edit_course_form{
    .set_catalog_title{
      height: 60px;
      display: flex;
      align-items: center;
      position: relative;
      h2{
        color: #333;
        font-size: 16px;
        margin-left: 24px;
        position: relative;
        font-weight: 600;
        &::after{
          content: '';
          position: absolute;
          left: -10px;
          top: 3px;
          width: 4px;
          height: 12px;
          background: #5397F7;
        }
      }
    }
    .tips{
      color: #F43D3D;
      font-size: 12px;
      margin-left: 10px;
      margin-bottom: 10px;
    }
    .platform_list{
      li{
        line-height: 40px;
        background: #f5f5f7;
        margin-bottom: 10px;
        .platform_name{
          color: #767484;
          font-size: 14px;
          margin: 0 5px 0 15px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/course/editCourseInfo.vue